import React from "react";

import ProjectV2 from "./ProjectV2";
import YourProjectHere from "./YourProjectHere";

export default props => {

    const projects = props.projects.filter(projectName => !!props.allProjects.find(project => project.node.frontmatter.title === projectName));
    
    return (
        <section className="projects-v2">
            <div className="anchor" id="portfolio"></div>
            <div className="fullscreen-projects">
                <div className="row">
                    { projects.map(projectName => props.allProjects.find(project => project.node.frontmatter.title === projectName) ).map( ( project, index) => {
                        if (project) {
                            return (
                                <ProjectV2 key={ project.node.frontmatter.title } project={ project.node } index={ index } />
                            );
                        } else {
                            return null;
                        }
                    })}
                    <YourProjectHere extraClass={ `col${ projects.length % 4 }` } />
                </div>
            </div>
        </section>
    );
};
